import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { InteractiveContentEntryComponent } from './interactive-content-entry/interactive-content-entry.component';

@NgModule({
  declarations: [InteractiveContentEntryComponent],
  imports: [CommonModule],
})
export class InteractiveContentModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Interactive Content': InteractiveContentEntryComponent,
    };
  }
}
